import InputTextFieldChips from './InputTextFieldChips';

export default InputTextFieldChips;
